import { BaseFlowNodeContainer } from "../Shared/BaseFlowNodeContainer/BaseFlowNodeContainer";
import { BottomHandle, TopHandle } from "../Shared/FlowNodeHandles";
import { LeftHandle, RightHandle } from "../Shared/FlowNodeHandles/MultiBottomHandle";

type NodeProps = {
    isConnectable: boolean;
    selected: boolean;
    children: JSX.Element;
    removeNodeIcon: JSX.Element | null;
    connectingNodesFrom: string | null;
    isHorizontal?: boolean;
    className?: string;
};

export function InputOutputNode({
    isConnectable,
    isHorizontal,
    selected,
    children,
    connectingNodesFrom,
    removeNodeIcon,
    className,
}: NodeProps) {
    return (
        <BaseFlowNodeContainer selected={selected} connectingNodesFrom={!!connectingNodesFrom} className={className}>
            <>
                {isHorizontal ? (
                    <LeftHandle isConnectable={isConnectable} />
                ) : (
                    <TopHandle isConnectable={isConnectable} />
                )}
                {removeNodeIcon}
                {children}
                {isHorizontal ? (
                    <RightHandle isConnectable={isConnectable} />
                ) : (
                    <BottomHandle isConnectable={isConnectable} />
                )}
            </>
        </BaseFlowNodeContainer>
    );
}
